import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Card,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardBody,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import CenterModal from "components/Common/CenterModal";
import InviteForm from "components/ParentingSpace/InviteMemberForm";
import ExpenseCategoryForm from "components/Expense/ExpenseCategoryForm";

import ExpenseCategory from "components/Expense/ExpenseCategory";
import ExpenseList from "components/Expense/ExpenseList";
import ExpenseStat from "components/Expense/ExpenseStat";
import ParentExpenseList from "components/Expense/ParentExpenseList";
const CryptoLending = props => {
  const toggleMenu = () => {
    // setIsMenu(!isMenu);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Enpense" breadcrumbItem="Enpense" />

          <Row>
            <Col xl="12">
             <ExpenseStat/>

              {/* <ExpenseCategory/>  */}
            </Col>
          </Row>

          <Row>
            <Col xl="12">
            {/* <ParentExpenseList/> */}
              <ExpenseList/>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CryptoLending;
